<svelte:head>
    <link rel='stylesheet' href='/global.css'>
    <link rel="stylesheet" type="text/css" href="css/charts.css" />
</svelte:head>

<script>
    import Filter from "./utils/filter.svelte"
    import Chart from "./charts/chart.svelte"
    import Header from "./header.svelte"

    import {
        loadMainChartData,
        loadSpecialOrFilteredChartData,
        tooltipFormatter,
        colorStops,
        chartOptions, formatLabels
    } from "../utils/charts";

    import {
        chartHeight,
        chartMarginBottom,
        plotLineColor
    } from '../utils/general'

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import {getLocalPropertyId} from "../utils/session";
    import {
        isDatesDefault,
        isDisplayDefault,
        isFilterDefault
    } from "./utils/filter";


    const router = getContext('router');


    let earliest;
    let filterData = JSON.parse(JSON.stringify(chartOptions));
    let data;
    let tempData;
    let totalKeywords;
    let chartConfig;
    let currentKeyword;
    let selectedChart = 'overview';
    let labels;
    let subchart = false;

    let selectedDate = 'all';

    let child;

    onMount(() => {

        assembleChartData();
    })

    let chartTextContent = {
        'keywords': {
            'overview': {
                'info': {
                    'title': 'Keywords - Übersicht',
                    'notice': 'Dieses Chart zeigt Ihnen alle Keywords aus Ihren Bewertungen während des gewählten Zeitraumes an.\n' +
                        '                Ein Schlagwort wird als Keyword gezählt, wenn es mehr als zweimal in Ihren Bewertungen verwendet wurde.<br />\n' +
                        '                <br />\n' +
                        '                Klicken Sie auf ein Keyword oder benutzen Sie das Suchfeld, um detaillierte Charts für ein Keyword anzuzeigen.<br />\n' +
                        '                <br />\n' +
                        '                Darstellungen:\n' +
                        '                <ul>\n' +
                        '                    <li><strong>Top 20</strong> - zeigt die 20 meistbenutzten Keywords an</li>\n' +
                        '                </ul>'
                },
                'data': {
                    'title': 'Keyword - Übersicht',
                }
            }
        },
        // 'errore': {
        //     'de': 'Keine Daten verfügbar.',
        //     'en': 'no data found.',
        // }
        'errore': 'Keine Daten verfügbar.'
    };

    let switchChart = (e, name) => {

        let target = e.currentTarget;

        document.querySelectorAll('div.active').forEach(element => {
            if (element != target ) {
                element.classList.remove('active');
            }
        })
        selectedChart = name;

        target.classList.add('active');

        chartConfig = false;

        // checkAllOptions();

        filterData['dates']['start'] = earliest;

        filterData['filter'] = {
            'platform': 'all',
            'rating': 'all',
            'sentiment': 'all',
            'age': 'all',
            'gender': 'all',
            'origin': 'all'
        }

        child.resetFilter(true);

        assembleChartData();
        selectedDate = 'all';

    };

    let receiveChartOptions = (data) => {

        filterData['filter'] = data.detail['map']['filter'];
        filterData['display'] = data.detail['map']['display'];

        // let filtered;
        // let isDates = false;
        // let specialView = false;
        //
        // if (!isFilterDefault(filterData['filter'])) {
        //
        //     filtered = true;
        // }
        //
        // if (!isDatesDefault(filterData['dates'], earliest)) {
        //
        //     isDates = true;
        // }
        //
        // if (!isDisplayDefault(filterData['display'])) {
        //
        //     specialView = true;
        // }
        //
        // if ((isDisplayDefault(filterData['display'])) && (!filtered) && (!isDates)) {
        //
        //     assembleChartData();
        // } else {
        //
        //     assembleChartData(specialView, filtered, isDates);
        // }

        checkAllOptions();

    };

    let receiveDateOptions = (data) => {

        filterData['dates']['start'] = data.detail['start']
        filterData['dates']['end'] = data.detail['end']
        selectedDate = data.detail['selected']

        checkAllOptions();

    };

    let checkAllOptions = () => {

        let isDates = true;
        let filtered = true;
        let specialView = true;

        if (isDatesDefault(filterData['dates'], earliest)) {

            isDates = false;
        }

        if (isFilterDefault(filterData['filter'])) {

            filtered = false;
        }

        if (isDisplayDefault(filterData['display'])) {

            specialView = false;
        }

        assembleChartData(specialView, filtered, isDates);

    };

    let assembleChartData = (specialView = false, filtered = false, isDates = false) => {

        let chartId = subchart ? `keyword_${selectedChart}__${currentKeyword}` : `keywords_${selectedChart}`;

        let chartType = subchart ? 'subchart' : 'chart';

        let propertyId = getLocalPropertyId();

        if (filtered || specialView || isDates) {

            if (filterData['dates']['start'] === 0) {

                filterData['dates']['start'] = earliest;
            }

            loadSpecialOrFilteredChartData(router, subchart, chartId, chartType, propertyId, filterData).then((chartData) => {

                data['data']['data'] = chartData['data'];
                data['data']['period'] = chartData['period'];


                totalKeywords = chartData['total'];

                chartHandler(specialView, filtered, isDates);

            });

        }
        else {

            if (earliest) {

                if (filterData['dates']['start'] === 0) {

                    filterData['dates']['start'] = earliest;
                }
            }

            loadMainChartData(router, subchart, chartId, chartType, propertyId, filterData).then((chartData) => {

                data = chartData

                totalKeywords = data['data']['total'];

                if (!earliest) {

                    earliest = chartData['settings']['meta']['earliest'];
                }

                if (filterData['dates']['start'] === 0) {

                    filterData['dates']['start'] = chartData['settings']['meta']['earliest'];
                }

                chartHandler(specialView, filtered, isDates);

            });

        }

    };

    let chartHandler = (specialView, filtered, isDates) => {

        chartConfig = false;

        if (!totalKeywords) {

            chartConfig = false;

            return;
        }

        if (currentKeyword) {

            switch (selectedChart) {

                case 'monthly':

                    chartConfig = handleChartDataKeywordTrend(data['data']);
                    break;

                case 'daily':

                    chartConfig = handleChartDataKeywordTrend(data['data']);
                    break;

                case 'platforms':

                    chartConfig = null;

                    setTimeout(() => {

                        chartConfig = setupChartPlatforms(data['data']);
                    },)

                    break;

                default:

                    chartConfig = handleChartDataKeywordTrend(data['data']);
            }

        }
        else {

            chartConfig = setupChartOverview(data['data']);
        }


        if (isDates) {

            if (selectedChart === 'platforms') {

                setTimeout(() => {

                    changeChartLabels();
                },1)

                return;
            }

            changeChartLabels();
        }

    };

    let changeChartLabels = () => {

        if (currentKeyword) {

            if (selectedChart === 'overview') {

                chartConfig['xAxis']['categories'] = formatLabels(data['data']['period']['type'], labels)
            }

            chartConfig['xAxis']['plotLines'] = Array.from({length: labels.length}).map((_, i) => {
                return { color: plotLineColor, width: 1, value: i }
            });

            chartConfig['xAxis']['labels']['step'] = labels.length > 7 ? 2 : 1;
        }

    };

    let setupChartOverview = (data) => {

        let chartData = { 'pos': [], 'neu': [], 'neg': [] };

        let maxCum = 0;

        for (const [mEntryKey, mEntry] of Object.entries(data['data'])) {

            if (mEntry['cum'] > maxCum) {

                maxCum = mEntry['cum'];
            }
        }

        let maxValues = { 'pos': 0, 'neg': 0};

        for (const [dpk, dp] of Object.entries(data['data'])) {

            if (chartOptions['display'] === 'all') {

                if (dp['cum'] < (maxCum * 0.1)) {

                    continue;
                }

            }

            chartData['pos'].push({
                name: dpk.toUpperCase(),
                value: (dp['pos'] !== 0) ? dp['pos'] : null
            });

            if (maxValues['pos'] < dp['pos']) {

                maxValues['pos'] = dp['pos'];
            }

            chartData['neg'].push({
                name: dpk.toUpperCase(),
                value: (dp['neg'] !== 0) ? dp['neg'] : null
            });

            if (maxValues['neg'] < dp['neg']) {

                maxValues['neg'] = dp['neg'];
            }

        }

        return {

            chart: {
                type: 'packedbubble',
                backgroundColor: 'transparent',
                height: (window.innerHeight * 0.53)
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            plotOptions: {
                packedbubble: {
                    marker: {
                        fillOpacity: 1
                    },
                    sizeBy: 'width',
                    turboThreshold: 0,
                    minSize: window.innerHeight * 0.02, // '50%',
                    maxSize: window.innerHeight * 0.15, // '250%',
                    /*zMin: 0,
                    zMax: 1000,*/
                    borderWidth: 0,
                    layoutAlgorithm: {
                        splitSeries: false,
                        initialPositions: 'random',
                        gravitationalConstant: 0.02, // 0.03
                        /*friction: -0.9,*/
                        seriesInteraction: true,
                        maxSpeed: 30,
                        parentNodeLimit: true,
                        enableSimulation: true
                    },
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                        filter: {
                            property: 'y',
                            operator: '>',
                            value: Math.max(maxValues['pos'], maxValues['neg']) * 0.5
                        },
                        style: {
                            color: 'white',
                            textOutline: 'none',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            fontSize: '1.6vh',
                            fontFamily: '\'Raleway\', sans-serif'
                        }
                    },
                    events: {
                        click: function (e) {
                            currentKeyword = e.point.name.toLowerCase();
                            subchart = true;
                            checkAllOptions();
                        }
                    }
                },
                animation: {
                    duration: 1
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    id: 'pos',
                    name: 'pos',
                    keyoshtype: 'keywords',
                    data: chartData['pos'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['pos']
                    },
                },
                /*{
                    id: 'neu',
                    name: 'neu',
                    data: [],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neu']
                    }
                },*/
                {
                    id: 'neg',
                    name: 'neg',
                    keyoshtype: 'keywords',
                    data: chartData['neg'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neg']
                    },
                }
            ]

        }
    };

    let handleChartDataKeywordTrend = (data, formatting = false) => {

        labels = [];
        let chartData = { 'pos': [], 'neu': [], 'neg': [] };

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk.charAt(0).toUpperCase() + dpk.slice(1));

            for (const [catk, cat] of Object.entries(dp)) {

                if (catk !== 'cum') {

                    chartData[catk].push(
                        (cat !== 0) ? cat : null
                    );

                }

            }

        }

        if (formatting) {

            labels = formatLabels(formatting, labels);
        }

        return {

            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                plotLines: Array.from({length: labels.length}).map((_, i) => {
                    return { color: plotLineColor, width: 1, value: i }
                }),
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: false,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: (labels.length > 14) ? 2 : 1,
                    y: chartMarginBottom
                }
            },
            yAxis: {
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    maxPointWidth: 20,
                    borderRadius: '0.89vh'
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    }
                }
            },
            series: [
                {
                    name: 'pos',
                    data: chartData['pos'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['pos']
                    }
                },
                {
                    name: 'neu',
                    data: chartData['neu'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neu']
                    }
                },
                {
                    name: 'neg',
                    data: chartData['neg'],
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['neg']
                    }
                }
            ]
        };

    };

    let setupChartPlatforms = (data) => {

        labels = [];
        let chartData = [];

        for (const [dpk, dp] of Object.entries(data['data'])) {

            labels.push(dpk);

            chartData.push(
                (dp['pct'] !== 0.0) ? dp['pct'] : null
            );

        }

        labels = formatLabels('platforms', labels);

        return {

            chart: {
                type: 'column',
                polar: true,
                backgroundColor: 'transparent',
                height: chartHeight
            },
            title: {
                text: null
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                useHTML: true,
                backgroundColor: null,
                borderWidth: 0,
                shadow: false,
                shared: false,
                formatter: tooltipFormatter
            },
            xAxis: {
                allowDecimals: false,
                categories: labels,
                lineWidth: 0,
                tickWidth: 0,
                labels: {
                    allowOverlap: true,
                    style: {
                        fontSize: '2.22vh',
                        wordBreak: 'break-all',
                        textOverflow: 'allow'
                    },
                    step: 1
                },
                backgroundColor: '#FFFFFF',
                borderRadius: '50%',
                shadow: {
                    color: 'rgba(119, 119, 119, 0.1)',
                    offsetX: 3,
                    offsetY: 4,
                    width: 20
                }
            },
            yAxis: {
                visible: false,
                allowDecimals: false,
                gridLineWidth: 0,
                title: null,
                labels: {
                    style: {
                        fontSize: '1.96vh'
                    },
                    step: 2
                }
            },
            plotOptions: {
                column: {
                    /*maxPointWidth: 20,*/
                    borderRadius: '1.2vh',
                    stacking: 'normal',
                    groupPadding: 0,
                    minPointLength: 100
                },
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    },
                    animation: {
                        duration: 500
                    },
                    pointPadding: 0.02
                }
            },
            series: [
                {
                    id: 'percent',
                    name: 'percent',
                    size: data['total'],
                    data: chartData,
                    color: {
                        linearGradient: {
                            x1: 0, x2: 1, y1: 0, y2: 1
                        },
                        stops: colorStops['percent']
                    }
                }
            ]

        };
    };

    let handleSearchMessage = (searchEvent) => {

        let actionType = searchEvent.detail['type'];
        let keyword =  searchEvent.detail['keyword'];

        switch (actionType) {

            case "newkeyword":

                currentKeyword = keyword;
                subchart = true;
                break;

            case "reset":

                subchart = false;
                selectedChart = 'overview';
                currentKeyword = "";

        }

        checkAllOptions();

    };

</script>

<Header
        showSearch={true}
        startDate={earliest}
        on:dates={receiveDateOptions}
        on:propertychange={assembleChartData}
        keyword={currentKeyword}
        on:searchevent={handleSearchMessage}
        selected={selectedDate}
/>

{#if data}

    <Filter
            data={data}
            on:filtersMenu={receiveChartOptions}
            bind:this={child}
    />

{/if}


<section>

    <div class="main">

        <div id="chart-stats">

            <div class="stats-item">

                <img class="stats-icon" src="images/icon-stats-keywords.svg" />

                <div class="stats-meta">

                    <div class="stats-title">{ currentKeyword ? 'Erwähnugen': 'Keywords' }</div>

                    {#if totalKeywords || totalKeywords === 0}
                        <div class="stats-num">{totalKeywords}</div>
                    {/if}


                </div>

            </div>

        </div>

        {#if currentKeyword && selectedChart !== 'platforms' }

            <div id="chart-legend">

                <div class="chart-legend-container" data-chartid="keyword_overview">

                    <div class="legend-item">

                        <img src="images/icon-legend-pos.svg" alt="Icon Pos" />
                        <div class="legend-text">Positive</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-neu.svg" alt="Icon Neu" />
                        <div class="legend-text">Neutrale</div>

                    </div>

                    <div class="legend-item">

                        <img src="images/icon-legend-neg.svg" alt="Icon Neg" />
                        <div class="legend-text">Negative</div>

                    </div>

                </div>

            </div>

        {/if}

        <Chart
            chartType="overview"
            chartConfig={chartConfig}
            currentPage="keywords"
            total={totalKeywords}
            keywordTitle={currentKeyword}
        />

    </div>

    <div id="chart-list" class="show">

        <div id="chart-icon-trend" class="chart-item type-trend active" data-chartid="reviews_overview" on:click|stopPropagation={(e) => switchChart(e, 'overview')}>

            <div class="item-title">
                Übersicht
            </div>

            <div class="item-icon">
                <img src={currentKeyword ? "images/chart-trend.svg" : "images/chart-overview.svg"} />
            </div>

        </div>

        {#if currentKeyword}

            <div id="chart-icon-monthly" class="chart-item type-periodic" data-chartid="reviews_monthly" on:click|stopPropagation={(e) => switchChart(e, 'monthly')}>

                <div class="item-title">
                    Verteilung <br />Monate
                </div>

                <div class="item-icon">
                    <img src="images/chart-periodic.svg" />
                </div>

            </div>

            <div id="chart-icon-daily" class="chart-item type-periodic" data-chartid="reviews_daily" on:click|stopPropagation={(e) => switchChart(e, 'daily')}>

                <div class="item-title">
                    Verteilung <br />Wochentage
                </div>

                <div class="item-icon">
                    <img src="images/chart-periodicshort.svg" />
                </div>

            </div>

            <div id="chart-icon-platform" class="chart-item type-polar" data-chartid="reviews_platforms" on:click|stopPropagation={(e) => switchChart(e, 'platforms')}>

                <div class="item-title">
                    Verteilung <br />Portale
                </div>

                <div class="item-icon">
                    <img src="images/chart-polar.svg" />
                </div>

            </div>

        {/if}

    </div>

</section>

<style>

    :global(#chart .highcharts-point) {
        stroke-width: 0;
        cursor: pointer;
    }

</style>

